import createReactClass from "create-react-class";

export default function(dependencies) {

    var html = createReactClass({
        render() {
            return null         
        },
    });

    return {
        html,
        config: {
            invisible: true,
        },
    };

};
